// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import {
	GaGeneralPageName,
	GaGeneralEvent,
	createGAEvent,
} from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import ShipmentProtectionShipping from '@/pages/shipment-protection-shipping/components/_ShipmentProtectionShipping.vue'
import type { TabbedFlowSectionContent } from '@/components/TabbedFlowSteps.vue'
import type { ExcludedCoverageContent } from '@/components/ExcludedCoverageSection.vue'
import { isGlobalSite } from '@/lib/checkService'

hybridPage()

export interface PageContent {
	banner: {
		title: string
		description: string
		toggle: {
			shipping: string
			shopping: string
		}
	}
	upgrade: {
		title: string
		img: string
		steps: UpgradeStep[]
	}[]
	choosePlusPlan: {
		title: string
		items: {
			icon: string
			title: string
			description: string
		}[]
	}
	planeCard: {
		theme: 'shoppingBasic' | 'shippingBasic' | 'shippingPlus'
		tag: string
		hasTag: boolean
		title: string
		description: string
		priceTitle: string
		price: string
		priceCaption: string
		buttonLabel: string
		listTitle?: string
		list: {
			icon: string
			label: string
		}[]
	}[]
	comparison: {
		title: string
		subtitle: string
		description?: string
		plans: {
			buyShipPlus: ComparisonPlan
			basic: ComparisonPlan
		}
		categories: ComparisonCategory[]
		disclaimer: {
			lines: string[]
			legal?: {
				jurisdiction: string
				termsUrl?: string
			}
		}
		settings: {
			showTooltips: boolean
			highlightRecommended: boolean
		}
	}
	flowContent: TabbedFlowSectionContent
	FAQ: {
		sectionTitle: string
		questions: string
		CTAButton: {
			text: string
			link: string
		}
		faqItems: {
			question: string
			answer: {
				items: {
					type: 'ordered' | 'unordered' | 'paragraph'
					content: (
						| string
						| {
								text: string
								subItems?: {
									type?: 'ordered' | 'unordered'
									items: string[]
								}
						  }
					)[]
				}[]
			}
			isOpen: boolean
		}[]
		linkCards: {
			title: string
			description: string
			href: string
		}[]
	}
	excludedCoverage: ExcludedCoverageContent
	footer: {
		title: string
		subtitle: string
		buttonText: string
	}
}

export interface ComparisonPlan {
	id: string
	name: string
	price: string
	recommended: boolean
	features?: string[]
	badge?: {
		text: string
		variant: 'primary' | 'secondary' | 'success'
	}
}

export interface ComparisonFeature {
	id: string
	label: string
	buyShipPlus: string | boolean
	basic: string | boolean
	hasTooltip?: boolean
	tooltipContent?: string
	category?: string
	priority?: 'high' | 'medium' | 'low'
	note?: string
}

export interface ComparisonCategory {
	id: string
	name: string
	description?: string
	hasInfo?: boolean
	infoContent?: string
	features: ComparisonFeature[]
	bgColor?: string
}

export interface UpgradeStep {
	title: string
	icon: string
	description: string
}

createApp({
	name: 'Shipment Protection Shipping',
	components: {
		ShipmentProtectionShipping,
	},
	setup() {
		const pageName = isGlobalSite()
			? GaGeneralPageName.ShoppingProtection
			: GaGeneralPageName.ShippingProtection

		setCurrentGaPageName(pageName)
		createGAEvent(GaGeneralEvent.PageLoad, {
			page_name: pageName,
		})

		const { pageContent } = window

		return {
			pageContent,
		}
	},
}).mount('#bsMain')
